import apiClient from '@/plugins/axios'

export default {

    postProcessosEmAtendimento(filter) {
        return apiClient.post(`atendimento/processoAtendimento`, { filter } )
    },

    getAtendimentosPorProcesso(id) {
        return apiClient.get(`atendimento/atendimentosPorPorcesso/${id}`)
    },

    getAtendimento() {
        return apiClient.get('atendimento')
    },

    getAtendimento(id) {
        return apiClient.get(`atendimento/${id}`)
    },

    postAtendimento(atendimento) {
        return apiClient.post(`atendimento`, { atendimento })
    },

    deleteAtendimento(id) {
        return apiClient.delete(`atendimento/${id}`)
    },

    getPendenciaProcesso(filter) {
        return apiClient.post(`pendenciasDoProcesso/pendencias`, { filter })
      }
}


// WEBPACK FOOTER //
// ./src/views/Atendimento/_services/AtendimentoService.js